import { useState } from 'react'
import { Button, Modal } from 'antd'
import { useSnapshot } from 'valtio'

import DocFileSvg from '@/assets/images/plugins/doc.svg'
import DocxFileSvg from '@/assets/images/plugins/docx.svg'
import PdfFileSvg from '@/assets/images/plugins/pdf.svg'
import TxtFileSvg from '@/assets/images/plugins/txt.svg'
import MdFileSvg from '@/assets/images/plugins/md.svg'
import { chatState } from '@/store'

import styles from './PluginBar.module.less'
import { pluginConfigDoc } from '@/components/Plugins/index'

interface IDocFileProps {
  fileName: string
}

const fileIconMap = {
  doc: DocFileSvg,
  docx: DocxFileSvg,
  pdf: PdfFileSvg,
  txt: TxtFileSvg,
  md: MdFileSvg,
}

export const DocFileIcon = ({ fileName }: IDocFileProps) => {
  const fileExtension = fileName?.split('.').pop() as keyof typeof fileIconMap

  return <img src={fileIconMap[fileExtension]} />
}

export const ParsedDocBar = () => {
  const [fold, setFold] = useState(false)
  const { plugins } = useSnapshot(chatState)
  const docs = plugins.get(pluginConfigDoc.value) || []

  if (!docs?.length) {
    return null
  }

  return (
    <div className={styles.parsedBar}>
      <div className={styles.parsedHeader}>
        <span>当前对话已解析成功文档</span>
        <Button
          type="link"
          onClick={() => {
            setFold(fold => !fold)
          }}
        >
          {fold ? '点击展开' : '点击收起'}
        </Button>
      </div>
      {fold ? null : (
        <div className={styles.parsedFileWrap}>
          {docs.map((item: any) => (
            <div
              key={item.url}
              className={styles.file}
              onClick={() => {
                const fileExtension = item.url.split('.').pop().toLowerCase()
                if (
                  fileExtension === 'pdf' ||
                  fileExtension === 'txt' ||
                  fileExtension === 'md'
                ) {
                  window.open(item.url)
                } else {
                  window.open(
                    `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(item.url)}`,
                  )
                }
              }}
            >
              <div className={styles.fileIcon}>
                <DocFileIcon fileName={item.name} />
              </div>
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
